// Internal
import { createAction } from '../../util/index';

/**
 * @function saveTableState
 * @param {object} params
 * @param {string} params.tableId Id of the table being created
 * @param {object} params.tableState React Table state to be stored globally
 */
export const saveTableState = createAction('SAVE_TABLE_STATE');
